import httpClient from "@/plugins/axios";

export const getPages = async (categoryId = null) => {
    const response = await httpClient.get('/v1/pages/', {
        params: {
            category: categoryId ?? null
        }
    });
    return response;
}

export const getPage = async (id) => {
    const response = await httpClient.get(`/v1/pages/${id}/`);
    return response;
}

export const downloadPageAttachment = async (pageId, attachmentId) => {
    const response = await httpClient.get(`/v1/pages/${pageId}/attachments/${attachmentId}/`,
        {
            responseType: 'blob',
        }
    );
    return response;
}
